"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var service_1 = require("../service");
var getAdditionalLinks = function (subdomain) {
    return (0, service_1.getService)()
        .get('/support/additional', { params: { subdomain: subdomain } })
        .then(function (_a) {
        var data = _a.data;
        return data;
    });
};
exports.default = getAdditionalLinks;
